module.exports = __webpack_public_path__ + "static/img/maprint-qrcode.3afa432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maprint-qrcode.png
// module id = pNiW
// module chunks = 1